import { createRouter, createWebHistory } from 'vue-router'
import NotFound from '@/views/NotFound.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "user" */ '@/views/HomeView'),
    meta: {
      authorized: true,
    },

  },
  {
    path: '/beta',
    name: 'beta',
    component: () => import(/* webpackChunkName: "guest" */ '@/views/BetaView'),
  },
  {
    path: '/editor/:project_id?',
    name: 'editor',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/EditorView'),
    meta: {
      authorized: true,
      lastMile: true,
    },
  },
  {
    path: '/projects',
    name: 'projects',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/ProjectsView'),
    meta: {
      authorized: true,
      lastMile: true,
    },
  },
  {
    path: '/backstage',
    name: 'backstage',
    component: () =>
      import(/* webpackChunkName: "admin" */ '@/views/BackstageView'),
    meta: {
      authorized: true,
      admin: true,
    },
    children: [
      {
        path: '',
        name: 'backstage:settings',
        component: () =>
          import(/* webpackChunkName: "admin" */ '@/views/BackstageSettings'),
      },
      {
        path: 'flows',
        name: 'backstage:workflows',
        component: () =>
          import(/* webpackChunkName: "admin" */ '@/views/WorkflowsView'),
      },
      {
        path: 'flow/:uuid?',
        name: 'backstage:workflow',
        component: () =>
          import(/* webpackChunkName: "admin" */ '@/views/WorkflowFormView'),
      },
      {
        path: 'presets',
        name: 'backstage:presets',
        component: () =>
          import(/* webpackChunkName: "admin" */ '@/views/PresetsView'),
      },
      {
        path: 'node-workflows',
        name: 'backstage:node-workflows',
        component: () =>
          import(/* webpackChunkName: "admin" */ '@/views/NodeWorkflowsView'),
      },
      {
        path: 'tpls',
        name: 'backstage:templates',
        component: () =>
          import(/* webpackChunkName: "user" */ '@/views/TemplatesView'),
      },
      {
        path: 'tpl/:tpl?',
        name: 'backstage:template',
        component: () =>
          import(/* webpackChunkName: "user" */ '@/views/TplEditView'),
      },
    ],
  },
  {
    path: '/by/:username',
    name: 'by',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/ProfileView'),
    meta: {
      authorized: true,
    },
  },
  {
    path: '/me',
    name: 'profile',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/ProfileView'),
    meta: {
      authorized: true,
    },
  },
  {
    path: '/league',
    name: 'league',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/LeagueView'),
    meta: {
      authorized: true,
    },
  },
  {
    path: '/league/bounty-house',
    name: 'bounty-house',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/BountyHouseView'),
    meta: {
      authorized: true,
    },
  },
  {
    path: '/league/museum-tower',
    name: 'museum-tower',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/MuseumTowerView'),
    meta: {
      authorized: true,
    },
  },
  {
    path: '/sign-up/:invite',
    name: 'sign-up',
    component: () => import(/* webpackChunkName: "guest" */ '@/views/SignUp'),
  },
  {
    path: '/sign-in',
    name: 'sign-in',
    component: () => import(/* webpackChunkName: "guest" */ '@/views/SignIn'),
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () =>
      import(/* webpackChunkName: "guest" */ '@/views/ResetPassword'),
  },
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () =>
      import(/* webpackChunkName: "guest" */ '@/views/NotAuthorized'),
  },
  {
    path: '/logout',
    name: 'logout',
    component: () =>
      import(/* webpackChunkName: "guest" */ '@/views/LogoutView'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound,
    meta: {
      lastMile: true,
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
